import React, { Component } from 'react';
import BD from '../../../../../../config';

var PageNumber = React.createClass({
  render: function(){
    return(
      <div className="pageNumber">
        <span>{this.props.pageID+1} / {BD.sequencePage.length}</span>
      </div>
    );
  }
});

export default PageNumber;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/PageNumber/index.jsx
 **/